import React, { Component, PropTypes } from 'react';
import Newsletter from './Newsletter';
import { loadNewsletter, loadNewsletters } from '../../../actions';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { push } from 'react-router-redux';
import SubscribeNewsletterBtn from './SubscribeNewsletterBtn';



class HomeNewsletter extends Component {
    constructor(props) {
        super(props);
        this.handleNewsletterClick = this.handleNewsletterClick.bind(this);
    } 

    handleNewsletterClick = (newsletterId) => {
        this.props.loadNewsletter(newsletterId);
        // Push the newsletter detail page to the browser
        this.props.push('/newsletter/' + newsletterId);
    }

    componentDidMount() {
        this.props.loadNewsletters();
    }

    render() {
        if (this.props.homePageNewsletters.isLoading) {
            return <span />;
        }
        let newsletters = this.props.homePageNewsletters;

        let newslettersList = newsletters.slice(1, 5).map((newsletter, index) => {
            return (
                <Newsletter 
                    key={index} 
                    newsletter={newsletter} 
                    excerptLength={30}
                    onClick={this.handleNewsletterClick.bind(this, newsletter.id)}
                    user = {this.props.auth}
                    openSignupFormRequest={this.props.openSignupFormRequest}
                    />
            );
        });

        return (
            <div className="section-container home-newsletter-wrapper">
                <div className="home-newsletter-header">
                    <h3 className="home-newsletter-section-title">News and Weekly Featured</h3>
                    <p className="section-description home-newsletter-description">Every week we feature organizations that work relentlessly to enhance the rights of women and girls across the globe and move the needle closer to gender equality</p>
                    <div className="home-newsletter-button-mobile">
                        <SubscribeNewsletterBtn 
                            user = {this.props.auth}
                            openSignupFormRequest={this.props.openSignupFormRequest}
                        />
                    </div>
                </div>
                <div className="home-newsletter-inner">
                    <div className="home-newsletter-left">
                        <Newsletter 
                            newsletter={this.props.homePageNewsletters[0]}
                            excerptLength={500} 
                            onClick={this.handleNewsletterClick.bind(this, this.props.homePageNewsletters[0].id)}
                            />

                        <div className="home-newsletter-button">
                            <SubscribeNewsletterBtn 
                                user = {this.props.auth}
                                openSignupFormRequest={this.props.openSignupFormRequest}
                            />
                        </div>
                        <div className="home-newsletter-right-title">Recent posts</div>
                    </div>
                    <div className="home-newsletter-right">
                        <div className="home-newsletter-right-title">Recent posts</div>
                        {newslettersList}
                    </div>
                </div>
            </div>
        );
    }
};

function mapStateToProps(state) {
    return state;
};

export default connect(
    mapStateToProps,
    {
        loadNewsletters,
        loadNewsletter,
        Link,
        push
    }
)(HomeNewsletter);





// WEBPACK FOOTER //
// ./src/components/home/HomeNewsletter/index.jsx